import moment from "moment";

const MONTH_FORMAT = "YYYY-MM";
const DATE_FORMAT = "YYYY-MM-DD";

export const CONTENT_COLUMN = "text";

const GRID_HEADER_HEIGHT = 80;
const GRID_ROW_HEIGHT = 40;
const GRID_SCROLLBAR_HEIGHT = 18;
const GRID_MIN_HEIGHT = 200;

export function currentMonth() {
  return moment().format(MONTH_FORMAT);
}

export function shiftMonth(month, delta) {
  return moment(month, MONTH_FORMAT, true)
    .add(delta, "months")
    .format(MONTH_FORMAT);
}

export function estimateGridHeight(rowCount) {
  return Math.max(
    GRID_MIN_HEIGHT,
    GRID_HEADER_HEIGHT + rowCount * GRID_ROW_HEIGHT + GRID_SCROLLBAR_HEIGHT
  );
}

export function buildMonthDays(month) {
  const start = moment(month, MONTH_FORMAT, true);
  if (!start.isValid()) return [];

  return Array.from({ length: start.daysInMonth() }, (_, index) =>
    start
      .clone()
      .date(index + 1)
      .format(DATE_FORMAT)
  );
}

const byStartTime = (a, b) =>
  String(a.startTime || "").localeCompare(String(b.startTime || ""));

export function groupLessonsByDay(month, lessons) {
  const lessonsByDate = (lessons || []).reduce((acc, lesson) => {
    if (!acc[lesson.date]) acc[lesson.date] = [];
    acc[lesson.date].push(lesson);
    return acc;
  }, {});

  return buildMonthDays(month).map(date => ({
    date,
    lessons: (lessonsByDate[date] || []).slice().sort(byStartTime)
  }));
}

export function buildGridRows(contents) {
  return (contents || []).map((content, index) => ({
    id: index,
    text: content.text,
    lessonIds: content.lessonIds || []
  }));
}

export function weekdayInitial(date, locale) {
  return moment(date, DATE_FORMAT)
    .locale(locale)
    .format("ddd")
    .charAt(0)
    .toUpperCase();
}
